import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const popIn = {
    hidden: { opacity: 0, scale: 0.6, x: 40 },
    visible: {
        opacity: 1,
        scale: 1,
        x: 0,
        transition: {
            type: 'spring',
            stiffness: 260,
            damping: 22,
        },
    },
};

const sparklePulse = {
    pulse: {
        scale: [1, 1.12, 1],
        boxShadow: [
            '0 0 0 0 rgba(232, 192, 125, 0.45)',
            '0 0 0 16px rgba(232, 192, 125, 0.0)',
            '0 0 0 0 rgba(232, 192, 125, 0.0)',
        ],
        transition: {
            duration: 2.4,
            repeat: Infinity,
            repeatType: 'loop',
            ease: 'easeInOut',
        },
    },
};

const Whatsapp = () => {
    const whatsappUrl = 'https://wa.me/94766111678';

    return (
        <motion.a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat with us on WhatsApp"
            initial="hidden"
            animate="visible"
            variants={popIn}
            className="fixed right-4 sm:right-6 md:right-8 top-1/2 -translate-y-1/2 z-50"
        >
            <motion.div
                variants={sparklePulse}
                animate="pulse"
                whileHover={{ scale: 1.12 }}
                whileTap={{ scale: 0.96 }}
                className="relative flex items-center gap-3 rounded-full px-4 py-3 sm:px-5 sm:py-3.5 bg-gradient-to-br from-[#1A2F2A] via-[#2F4A43] to-[#4A7C76] text-white shadow-2xl"
            >
                <span className="absolute inset-0 rounded-full bg-[#E8C07D]/15 blur-md" />
                <span className="relative z-10 flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#E8C07D] text-[#1A2F2A] shadow-lg">
                        <FaWhatsapp className="h-6 w-6" />
                    </span>
                    <span className="hidden sm:block text-sm sm:text-base font-medium tracking-wide">
                        Chat on WhatsApp
                    </span>
                </span>
            </motion.div>
        </motion.a>
    );
};

export default Whatsapp;
